module.exports = __webpack_public_path__ + "media/images/views/talent/talent-lp-pc-2d7d95f03d839369e2fbcdfa6f481215.jpg";